export default __webpack_public_path__ + "static/media/8.79c6235e.jpeg";